import React, { useState } from "react";

import { MagnifyingGlass, XCircle } from "phosphor-react";
import PropTypes from "prop-types";

import StringHelper from "~/helpers/StringHelper";

import InputGroup from "./InputGroup";

function SearchInput({ onSearch, minLength = 1, ...inputProps }) {
  const [touched, setTouched] = useState(false);
  const [searched, setSearched] = useState("");

  const handleChange = (value) => {
    setSearched(value);

    if (
      value.length >= minLength ||
      (touched && StringHelper.isNullOrEmpty(value))
    ) {
      onSearch && onSearch(value);

      if (!touched) {
        setTouched(true);
      }
    }
  };

  return (
    <InputGroup
      type="text"
      prefix={<MagnifyingGlass weight="bold" color="#939393" size={20} />}
      suffix={
        <button
          color="transparent"
          onClick={() => handleChange("")}
          className={`px-0 py-0 ${
            searched.length > 0 ? "visible" : "invisible"
          }`}
        >
          <XCircle weight="fill" color="#939393" size={20} />
        </button>
      }
      {...inputProps}
      value={searched}
      onChange={(e) => {
        handleChange(e.target.value);
      }}
      noForm
    />
  );
}

SearchInput.propTypes = {
  onSearch: PropTypes.func.isRequired,
  minLength: PropTypes.number,
};

export default SearchInput;
